import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { axiosGetData } from "@shared/api/clients";

import type {
  GeneralRaisingHistoryFilters,
  ListGeneralRaisingHistoriesResponse,
} from "./generalRaisingHistory.types";

const GENERAL_RAISING_HISTORY_QUERY_KEY = "general-raising-history";

export const getGeneralStructureRaisingHistory = async (
  structureId: string,
  params?: GeneralRaisingHistoryFilters,
): Promise<ListGeneralRaisingHistoriesResponse> => {
  const cleanParams = Object.fromEntries(
    Object.entries(params ?? {}).filter(
      ([, value]) => value !== undefined && value !== "",
    ),
  );

  return axiosGetData<ListGeneralRaisingHistoriesResponse>(
    `v1/general/structures/${structureId}/raising-history`,
    cleanParams,
  );
};

export const generalStructureRaisingHistoryQueryOptions = (
  structureId: string,
  params?: GeneralRaisingHistoryFilters,
) => ({
  queryKey: [GENERAL_RAISING_HISTORY_QUERY_KEY, structureId, params ?? {}],
  queryFn: () => getGeneralStructureRaisingHistory(structureId, params),
});

export const useGeneralStructureRaisingHistoryQuery = (
  structureId: string | undefined,
  params?: GeneralRaisingHistoryFilters,
  options?: Partial<UseQueryOptions<ListGeneralRaisingHistoriesResponse, AxiosError>>,
) =>
  useQuery<ListGeneralRaisingHistoriesResponse, AxiosError>({
    ...generalStructureRaisingHistoryQueryOptions(structureId ?? "", params),
    enabled: Boolean(structureId),
    ...options,
  });
